import React from 'react'
import Helmet from 'react-helmet'
import './style.css'

const Cloud = () => (
  <div className='cloud'>
    <Helmet title='Cisco Cloud' />
    <a href='#Cisco'>
      <img
        src='/_ima/cisco-cloud-banner.jpg'
        alt='
        Cisco Cloud Advanced Services:
        Appko is responsible for more deployments of
        Cisco Cloud softwre than any other consulting company'
      />
    </a>
    <div className='article'>
      <h2>Your Cloud, Your Way</h2>
      <p>
        Are you looking to take your cloud to the next level
        with automation and orchestration? Or do you want to build a cloud from
        the ground up? Appko’s cloud experts are masters of Cisco Cloud
        software and platform. Appko can assist with modernizing and customizing
        your cloud to your organization’s specific needs.
      </p>
      <p>
        Appko has built public, private, and hybrid
        clouds for some of the biggest service providers and
        companies in the world. Appko focuses on the business solution,
        leveraging the best of breed technologies, and can develop
        solutions to bridge gaps in vendor solutions.
      </p>
      <p>
        Appko’s engineers were a part of the Cisco engineering team
        that built IAC, and continue to assist Cisco with its development.
        Our deep knowledge of and experience with IAC equips us uniquely
        to implement and customize an IAC solution for your business.
      </p>
      <div align='center' className='gallery-container'>
        <h1>
          <h2>Cisco Intelligent Automation for Cloud (IAC):</h2>
          <br />
          <img
            src='/_ima/CIAC_Overview.jpg'
            alt='An overview of Cisco IAC'
            className='block-title'
          />
          <br />
        </h1>
      </div>
      <p>
        Appko can assist you with developing, configuring,
        upgrading, and migrating your CIAC setup
      </p>
      <ul>
        <li>Design and Architecture</li>
        <li>Test, dev, pilot, and production</li>
        <li>Implementation into you organization</li>
      </ul>
      <h3>Prime Service Catalogue and Portal</h3>
      <ul>
        <li>UI / portal customized for your organization</li>
        <li>Service item / service catalogue</li>
      </ul>
      <h3>Process Orchestration</h3>
      <ul>
        <li>Automation of services</li>
        <li>integration into services within org: LDAP, AD</li>
      </ul>
      <h3>Network automation</h3>
      <ul>
        <li>
          Creation of real network topologies that focus on users
          and the applications that they use
        </li>
        <li>
          Dynamic installation of virtual network devices
          on demand with on boarding and off boarding of
          tenants and organizations
        </li>
        <li>
          Lifecycle operations for Layers 2 through 7,
          including modification and removal, that
          maintain the relationships and life cycles of users,
          tenant organizations, and applications associated with network capabilities
        </li>
      </ul>
      <h3>Cloud governance</h3>
      <ul>
        <li>
          Allows organizations to establish quotas and
          limits ahead of time, eliminating the surprise of
          large bills from public service providers
        </li>
        <li>
          Gives end users an understanding of the costs
          of services at time of ordering before requests are finalized
        </li>
        <li>
          Financial or consumption limits deliver financial
          granularity for project budgets
        </li>
        <li>
          Allows enterprises or service providers to fund service
          expansion or staff additions from savings or
          from incremental revenue derived from offering Cisco
          IAC services to their customers
        </li>
      </ul>
      <h3>Multi-cloud management</h3>
      <ul>
        <li>
          Cisco IAC delivers out-of-the-box provisioning
          and management capabilities for Amazon EC2,
          <a href='#openstack'>OpenStack</a>
          <a href='#vmware'>VMware</a>
          vCloud Director, and VMware vSphere and is designed to be
          extended to additional hypervisors and cloud providers
        </li>
        <li>
          Multicloud management allows enterprises and service
          providers to tailor service offerings to the specific costs
          and functions of hypervisor platforms and specific project needs
        </li>
        <li>
          Cisco IAC supports two infrastructure layers:
          OpenStack and Cisco UCS Director
        </li>
      </ul>
      <h3>ACM and Orchestration Services:</h3>
      <p>
        Cisco IAC is tightly coupled with Application Configuration Management
        tools such as Puppet and Chef. Appko can assist you with customizing,
        orchestrating services, and implementing ACM into your IAC platform.
      </p>
      <p>
        We can also assist you in integrating your ACM tool of choice,
        like Salt and Ansible, into you IAC platform.
      </p>
      <div className='text-wrapper'>
        <div>
          <img
            className='right w60'
            src='/_ima/appko-lifecycle-services.png'
            alt='Appko can assist you in planning, building, and managing your cloud'
          />
        </div>
        <div>
          <h2>Lifecycle Service Offerings:</h2>
          <ul>
            <li>Design, architecture and planning</li>
            <li>Custom Development services</li>
            <li>Integrations</li>
            <li>Implementation services</li>
            <li>Production pilot, Production release</li>
            <li>Post Production support</li>
            <li>Sustaining Services and maintenance support</li>
          </ul>
        </div>
      </div>
      <h2>Cisco One Services:</h2>
      <ul>
        <li>
          Automate your infrastructure to deliver unified computing,
          network, storage, and virtualization instances that span virtual
          and bare-metal resources.
        </li>
        <li>
          Use the automation to fulfill infrastructure orders
          that are tailored to your specific policies and governance,
          and to deliver cloud-ready infrastructure services in minutes,
          improving time-to-value ratios.
        </li>
        <li>
          Appko can assist you with your Cisco One ECS implementation
          and customization.
        </li>
      </ul>
      <p>Our engineers are experts in all Cisco One technologies, including:</p>
      <ul>
        <li>Intercloud Fabric (ICFB)</li>
        <li>UCS Director (UCSD)</li>
        <li>Prime Service Catalogue (PSC)</li>
        <li>Virtual Application Container Services (VACS)</li>
        <li>Application Centric Infrastructure (ACI)</li>
        <li>Process Orchestrator (PO)</li>
      </ul>
      <iframe
        title='video'
        width='560'
        height='315'
        src='https://www.youtube.com/embed/cehYmEXf898'
        frameBorder='0'
        allowFullScreen
      />
      <h2>Technical Expertise:</h2>
      <ul>
        <li>Public, Private, and Hybrid cloud</li>
        <li>Business solution focus</li>
        <li>Best of breed technologies</li>
        <li>World class engineering resources</li>
        <li>Custom development</li>
      </ul>
      <a
        href='#submenu'
        id='vmware'
      >
        <img
          src='/_ima/contact-us.png'
          alt='arrow'
          width='160'
          height='40'
        />
      </a>
    </div>
    <div id='insidebanner'>
      <img
        src='/_ima/vmware-banner.jpg'
        alt='VMware Professional Services: Deploying VMware for organizations since 2007'
      />
    </div>
    <div className='article'>
      <h2>Your Cloud, Your Way</h2>
      <p>
        Do you want to take advantage of the proven power and support of VMware?
        Or do you need some help extending and maintaining your current VMware setup?
        Appko’s cloud experts can help your business with all of its VMware needs.
      </p>
      <p>
        Appko has built public, private, and hybrid clouds for
        some of the biggest service providers and companies in the world.
        Appko focuses on the business solution, leveraging the best
        of breed technologies, and can develop solutions to bridge
        gaps in vendor solutions.
      </p>
      <h2>VMware Technologies:</h2>
      <ul>
        <li>vCenter</li>
        <li>vSphere</li>
        <li>vCloud Suite</li>
        <li>vRealize Suite</li>
        <li>ESXi</li>
        <li>Virtual SAN</li>
        <li>NSX</li>
      </ul>
      <img
        src='/_ima/vmware-cert-2.png'
        alt='Appko is a VMware certified professional company'
        className='w50'
      />
      <h2>Lifecycle Service Offerings:</h2>
      <h3>Plan</h3>
      <p>
        Providing Businesses with a roadmap for implementing VMware
        and Cloud based on organization requirements
      </p>
      <ul>
        <li>Business justification, use cases, and ROI analysis</li>
        <li>Strategy and roadmap documentation</li>
        <li>Cost benefit Analysis</li>
        <li>Cloud readiness Assessment</li>
        <li>Cloud migration Planning</li>
        <li>Cloud architecture</li>
        <li>Comparative analysis between open source and licensed model</li>
      </ul>
      <h3>Build</h3>
      <p>
        Assisting organizations with customization and implementation
        of VMware based on organizational requirements
      </p>
      <ul>
        <li>Hypervisor selection and configurations</li>
        <li>Hardware considerations: server, storage, network</li>
        <li>Portal customizations: self service</li>
        <li>Orchestration and Automation</li>
        <li>Integration with Directory Services: LDAP, Active Directory, ...</li>
        <li>Application Configuration Management: Puppet, Chef, ...</li>
        <li>Security architecture and policy</li>
        <li>Elastic network analysis and design</li>
        <li>Production pilot, production release</li>
      </ul>
      <h3>Manage</h3>
      <p>
        Providing support and maintenance to your organization
        {"'"}
        s VMware environment as your cloud scales to organizational requirements
      </p>
      <ul>
        <li>QA and Testing</li>
        <li>Post Production support</li>
        <li>Sustaining Services and maintenance support</li>
        <li>Custom Development services</li>
        <li>Integrations</li>
      </ul>
      <h2>Experience:</h2>
      <ul>
        <li>Public, Private, and Hybrid cloud</li>
        <li>Business solution focus</li>
        <li>Best of breed technologies</li>
        <li>World class engineering resources</li>
        <li>Custom development</li>
        <li>Migrating Applications</li>
      </ul>
      <a
        href='#submenu'
        id='openstack'
      >
        <img
          src='/_ima/contact-us.png'
          alt='arrow'
          width='160'
          height='40'
          border='0'
        />
      </a>
    </div>
    <img
      src='/_ima/openstack-banner.jpg'
      alt='Openstack Consulting: Proven Openstack Professionals'
    />
    <div className='article'>
      <h2>Your Cloud, Your Way</h2>
      <p>
        Do you want to take advantage of the license free,
        open source power of Openstack? Or do you need some help
        extending and maintaining your current Openstack setup?
        Appko’s cloud experts can help your business with all of
        its Openstack needs.
      </p>
      <br />
      <blockquote>
        <p>
          {'"'}
          OpenStack is an attractive private cloud option for enterprises ...
          But it
          {"'"}
          s best to go with an implementation partner if your IT team doesn
          {"'"}
          t
          have OpenStack skills ... You need consulting; you need training ...
          Right now, you need to have a pretty big team if you
          {"'"}
          re going to
          do it from scratch
          {'"'}
        </p>
        <footer>
          <cite>
            <a
              href='http://searchcloudcomputing.techtarget.com/news/4500245245/Beware-the-steep-OpenStack-install-learning-curve'
            >
              – Dave Bartoletti, Forrester Reasearch, Inc.
              - Beware the Steep OpenStack Install Learning Curve
            </a>
          </cite>
        </footer>
      </blockquote>
      <br />
      <p>
        Appko has built public, private, and hybrid clouds for some
        of the biggest service providers and companies in the world.
        Appko focuses on the business solution, leveraging the best
        of breed technologies, and can develop solutions to bridge gaps
        in vendor solutions.
      </p>
      <h2>Openstack Technologies:</h2>
      <p>
        Appko has experience in all openstack technologies, including
        the following:
      </p>
      <img
        src='/_ima/appko-openstack.png'
        alt='An overview of Openstack technologies
        including: Horizon, Nova, Neutron, Swift, Cinder,
        Keysotne, Glance, Heat, Ceilometer, Trove, Shara, and Ironic'
        className='img-openstack'
      />
      <p>
        The
        <a href='https://www.openstack.org/software/roadmap/'> Openstack Roadmap </a>
        contains information on the latest realeases of Openstack,
        as well as planned and in-development feature for future releases.
      </p>
      <h2>Lifecycle Service Offerings:</h2>
      <p>
        Whether you are in the midst of planning or building your cloud,
        Appko offers services to support the whole lifecycle of your cloud.
        {' '}
      </p>
      <h3>Build</h3>
      <p>
        Assisting organizations with customization and implementation
        of Openstack based on organizational requirements
      </p>
      <ul>
        <li>Hypervisor selection and configurations</li>
        <li>Hardware considerations: server, storage, network</li>
        <li>Portal customizations: self service</li>
        <li>Orchestration and Automation</li>
        <li>Integration with Directory Services: LDAP, Active Directory, ...</li>
        <li>Application Configuration Management: Puppet, Chef, ...</li>
        <li>Security architecture and policy</li>
        <li>Elastic network analysis and design</li>
        <li>Production pilot, production release</li>
      </ul>
      <h3>Manage</h3>
      <p>
        Providing support and maintenance to your organization
        {"'"}
        s Openstack environment as your cloud scales to organizational requirements
      </p>
      <ul>
        <li>QA and Testing</li>
        <li>Post Production support</li>
        <li>Sustaining Services and maintenance support</li>
        <li>Custom Development services</li>
        <li>Integrations</li>
      </ul>
      <h2>Experience:</h2>
      <ul>
        <li>Public, Private, and Hybrid cloud</li>
        <li>Business solution focus</li>
        <li>Best of breed technologies</li>
        <li>World class engineering resources</li>
        <li>Custom development</li>
        <li>Migrating Applications</li>
      </ul>
      <a
        href='#submenu'
        id='cloud'
      >
        <img
          src='/_ima/contact-us.png'
          alt='arrow'
          width='160'
          height='40'
        />
      </a>
    </div>
    <img
      src='/_ima/insidebanner-mycloudpod.jpg'
      alt='myCloudPod. True Self Service'
    />
    <div className='article'>
      <p>
          Appko Cloud Engineering has built some fantastic Cloud
          Computing solutions for some of the best names in the industry.
          We have also developed our own product, although we no longer
          support it. myCloudPod is still a very good reference archetecture
          and demistrates Appko
        {"'"}
          s deep engineering talent in the area.
      </p>
      <h2>What is a myCloudPod?</h2>
      <p>
          myCloudPod is a true Self-Service Cloud computing experience
          for your own private infrastructure.  mycloudPod provides
          a complete cloud solution for your converged infrastructure
          which will drive user adoption and success at all levels of
          your organization.
      </p>
      <p>myCloudPod + Your Pod = Cloud Computing</p>
      <p>
          Its easy to get started with myCloudPod.
          We offer a SaaS solution that can be set up to your
          infrastructure in less than a day at a low cost.
          Your organization will quickly have a self-service
          cloud ready for your users.  Your users are empowered,
          IT become cloud leaders, and VARs sell more.
      </p>
      <h2>Solution</h2>
      <img
        src='/_ima/mcp_solution.png'
        className='img-solution'
        alt='myCloudPod completes your converged infrastructure, no matter your setup'
        width='239'
        height='454'
      />
      <p>
        Converged infrastructure with tools for administrators
        is not a complete solution. myCloudPod adds user self-service
        for cloud compute to complete the solution.
        mycloudPod is agnostic to your converged infrastructure preference.
        Your Pod, now It’s Your Cloud.
      </p>
      <p>
        <span>
          <img
            name='vmware'
            src='/_ima/VMwareReady.gif'
            width='102'
            height='48'
            alt='vmware'
          />
        </span>
      </p>
      <img
        name='mycloudpod'
        src='/_ima/mcp_experience.png'
        width='244'
        height='233'
        alt='my Cloud pod'
      />
      <div>
        <h2>Experience - Built For Humans</h2>
        <p>
          myCloudPod delivers an easy, intuitive,
          and beautiful experience provisioning servers in the cloud.
          The experience of myCloudPod transforms users, and drives high adoption.
        </p>
        <p><strong>Cloud Computing for Humans.</strong></p>
      </div>
      <div>
        <h2>Success</h2>
        <p>
          myCloudPod brings success to the entire lifecycle of the CI
          investment. Users are empowered, IT becomes a leader, and VARs
          provide more complete solutions.
        </p>
        <img
          src='/_ima/mcp_success1.jpg'
          className='left-image'
          alt='logo1'
          width='80'
          height='80'
        />
        <p>
          <strong>Empower Users:</strong>
          Users are empowered to create environments for their servers.
          mycloudPod is intuitive and a beautiful user experience.
          myCloudPod does not require hours of training concepts like on
          networking, virtualization, storage, and administration.
          Users have immediate access to your private cloud.
        </p>
        <img
          src='/_ima/mcp_success2.jpg'
          className='left-image'
          alt='logo2'
          width='80'
          height='62'
        />
        <p>
          <strong>IT Leads:</strong>
          Many CIO
          {"'"}
          s and IT leaders are building roadmaps to the cloud.
          myCloudPod helps IT lead on the new paradigm shift to the cloud
          and provides a real world IT self service model to their organization.
          Now IT leaders can begin shaping their organization to provide ITIL
          service.
        </p>
        <img
          src='/_ima/mcp_success3.png'
          className='left-image'
          alt='logo3'
          width='80'
          height='107'
        />
        <p>
          <strong>Sell:</strong>
          VARs now have the ability to sell a complete solution to their customers.
          myCloudPod + converged infrastructure is a complete cloud solution.
          Conversations go from line item SKUs to strategic long term solution
          conversations.  VAR is now in the advisor role to the customer.
        </p>
      </div>
      <div>
        <h2>myCloudPod capabilities</h2>
        <img
          src='/_ima/mcp_pods.png'
          className='left-image'
          alt='pods icon'
          width='28'
          height='24'
        />
        <p>myCloudPod PODs</p>
        <ul>
          <li>
            Provision Pod: create a new Pod in either the Public
            or Private network.
          </li>
          <li>
            Firewall: Access Rules provides a route from outside
            the Pod to Servers inside the Pod.
          </li>
          <li>
            VPN: VPN Accounts allow full access to the Servers inside a
            Pod using standard Windows VPN. No VPN client required.
          </li>
          <li>
            Load Balance: Spread the load for a service running on multiple
            Servers. Multiple web servers can be used for a single website.
          </li>
          <li>
            IP Subnet and IP Management: All IP networks are dynamically
            created and managed in the background without any input from users.
          </li>
          <li>
            No networking experience needed: Your users can easily and quickly create
            Pods, while all the networking services are automated.
          </li>
        </ul>
        <img
          src='/_ima/mcp_servers.png'
          className='left-image'
          alt='server icon'
          width='31'
          height='26'
        />
        <p>Servers</p>
        <ul>
          <li>Provision Servers: create, edit, and remove servers.</li>
          <li>Backups: create backups and restore to any of the backups.</li>
          <li>Disks: create and remove additional disks for your Servers.</li>
          <li>
            Configure: adjust the amount of memory or number of CPUs for
            your Servers.
          </li>
          <li>On/Off/Suspend: boot/reboot, shutdown, or suspend your Servers.</li>
          <li>
            KVM (Console): Access your Servers from myCloudPod with
            Keyboard/Video/Mouse control in the web portal.
          </li>
          <li>
            Define Templates: create a new Template from any existing
            Server. Templates are used as the base of new Servers.
          </li>
        </ul>
        <img
          src='/_ima/mcp_saas.png'
          className='left-image'
          alt='saas icon'
          width='32'
          height='25'
        />
        <p>Saas</p>
        <ul>
          <li>
            Borderless Networks: Access your infrastructure without
            need  of firewall rules or special network setup.
          </li>
          <li>
            Deployment in 1 Day: myCloudPod is set up for new customers
            within hours.
          </li>
          <li>No Project, No Software, No Risk</li>
          <li>
            User Accounts: User administration for your Cloud
            is handled  within myCloudPod. You can add/remove your own users.
          </li>
          <li>
            Manage CI Resources: Control which infrastructure your
            users are provisioning to.
          </li>
        </ul>
        <a href='#submenu'>
          <img
            src='/_ima/contact-us.png'
            alt='arrow'
            width='160'
            height='40'
            border='0'
          />
        </a>
      </div>
    </div>
  </div>
)

export default Cloud
